export enum Weekday {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export const weekdayToNumber = (weekday: Weekday) => {
  if (weekday === Weekday.Monday) {
    return 1;
  }
  if (weekday === Weekday.Tuesday) {
    return 2;
  }
  if (weekday === Weekday.Wednesday) {
    return 3;
  }
  if (weekday === Weekday.Thursday) {
    return 4;
  }
  if (weekday === Weekday.Friday) {
    return 5;
  }
  if (weekday === Weekday.Saturday) {
    return 6;
  }
  if (weekday === Weekday.Sunday) {
    return 7;
  }

  return -1;
};

export const numberToWeekday = (numberWeekday: number): string => {
  if (numberWeekday === 1) {
    return Weekday.Monday;
  }
  if (numberWeekday === 2) {
    return Weekday.Tuesday;
  }
  if (numberWeekday === 3) {
    return Weekday.Wednesday;
  }
  if (numberWeekday === 4) {
    return Weekday.Thursday;
  }
  if (numberWeekday === 5) {
    return Weekday.Friday;
  }
  if (numberWeekday === 6) {
    return Weekday.Saturday;
  }
  if (numberWeekday === 7) {
    return Weekday.Sunday;
  }

  return 'unknown';
};
